import { useEffect, useState } from 'react'

/**
 * Hat die bedienende Person Bewegung abbestellt?
 *
 * Im Stylesheet ist `@media (prefers-reduced-motion: reduce)` der übliche Weg,
 * und dabei bleibt es überall dort, wo es nur um eine Animation geht. Es reicht
 * aber nicht, wenn die Bewegung **nicht** aus CSS kommt: Ein Aufmacher, der
 * seine Nachricht von selbst wechselt, bewegt sich auch ohne Überblendung —
 * dort muss die Anwendung selbst wissen, dass sie stillhalten soll.
 *
 * `addListener`/`removeListener` als Rückfall: Safari kennt `addEventListener`
 * an `MediaQueryList` erst ab 14, und die Anwendung läuft auch auf älteren
 * Schulgeräten.
 */
const ABFRAGE = '(prefers-reduced-motion: reduce)'

export default function usePrefersReducedMotion() {
	const [wenigerBewegung, setWenigerBewegung] = useState(() => {
		// jsdom in den Tests kennt matchMedia nicht.
		if (typeof window === 'undefined' || !window.matchMedia) return false

		return window.matchMedia(ABFRAGE).matches
	})

	useEffect(() => {
		if (typeof window === 'undefined' || !window.matchMedia) return undefined

		const abfrage = window.matchMedia(ABFRAGE)
		const merken = ereignis => setWenigerBewegung(ereignis.matches)

		if (abfrage.addEventListener) abfrage.addEventListener('change', merken)
		else abfrage.addListener(merken)

		return () => {
			if (abfrage.removeEventListener) abfrage.removeEventListener('change', merken)
			else abfrage.removeListener(merken)
		}
	}, [])

	return wenigerBewegung
}
